const KeenSlider = window.KeenSlider

class ProductCardGallery extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onGridSwitcherChange = this.onGridSwitcherChange.bind(this)
    this.listeners.add(window, 'grid-switcher:change', this.onGridSwitcherChange)
  }

  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        rubberBand: false,
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        window.BAO.Carousel.plugins.setInitialised(),
        window.BAO.Carousel.plugins.useDots(this.els?.dot?.elements),
      ],
    )
  }

  onGridSwitcherChange () {
    requestAnimationFrame(() => {
      this.restartCarousel()
      this.carousel = this.setupCarousel()
    })
  }

  restartCarousel () {
    if (this.carousel?.destroy) {
      this.carousel.destroy()
    }
    this.carousel = null

    if (this.els.slides?.element) {
      this.els.slides.element.removeAttribute('data-initialised')
    }
  }

  disconnectedCallback () {
    this.restartCarousel()
    super.disconnectedCallback()
  }
}

if (!customElements.get('product-card-gallery')) {
  customElements.define('product-card-gallery', ProductCardGallery)
}
